export const Blogs = [
    {
        id:1,
        name:"Production ready Web application for all AI enthusiasts",
        tags:["react","AI","styled-components"],
        date:"2023-2024",
        imgSrc:"https://res.cloudinary.com/practicaldev/image/fetch/s--sBeV06Xc--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/2yrzy75q4dzibqz6rf82.png",
       // link:"https://dev.to/codebucks/build-website-with-reactjs-styled-components-and-gsap-for-scrolling-animations-2f10"
    },
    {
        id:2,
        name:"SIMS like Multiplayer game",
        tags:["react","react-three fiber","styled-components"],
        date:" Summer 2024",
        imgSrc:"https://media.contentapi.ea.com/content/dam/eacom/SIMS/220923-franchise-page-rebrand/images/2022/09/the-sims-tile-the-sims-mobile.png.adapt.crop16x9.652w.png",
        //link:"https://codebucks.hashnode.dev/react-hamburger-menu"
    },
    {
        id:3,
        name:"3D Portfoilio website",
        tags:["react","react-three-fiber","blender"],
        date:"Mid 2024",
        imgSrc:"https://vanschneider.com/blog/content/images/2021/07/Project-cover.png",
       // link:"https://codebucks.hashnode.dev/react-loading-screens"
    },
    {
        id:4,
        name:"Award Winner customized 3D ATMOS website",
        tags:["react","framer-motion"],
        date:"fall 2024",
        imgSrc:"https://i.graphicmama.com/blog/wp-content/uploads/2022/10/13115313/creative-pastel-color-3d-infographic-website.jpg",
       // link:"https://dev.to/codebucks/build-redux-react-todo-list-app-with-animations-using-framer-motion-1mp1"
    },
    {
        id:5,
        name:"FullStack E-commerce website",
        tags:["react","MERN","web-development"],
        date:"2024",
        imgSrc:"https://www.softwebsolutions.com/wp-content/uploads/2023/04/full-stack-accelerates-your-e-commerce-development.jpg",
       // link:"https://codebucks.hashnode.dev/what-is-higher-order-component"
    },
    
  
] 